import { AnyAction, applyMiddleware, CombinedState, combineReducers, createStore, Reducer } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';
import { providerConfigReducer } from 'containers/LandingPage/store/reducers';
import { logPageReducer } from 'containers/LogPage/store/reducers';
import { ProvidersConfigState } from 'containers/LandingPage/store/reducers/providersConfig.reducer';
import { LogPageState } from 'containers/LogPage/store/reducers/logPage.reducer';
import manifestConfigReducer, {
  ManifestConfigState,
} from 'providers/manifest/containers/ManifestPage/store/reducers/manifestConfig.reducer';

export interface AppStates {
  providersConfig: ProvidersConfigState;
  logPage: LogPageState;
  manifestConfig: ManifestConfigState;
}
const composeEnhancers = composeWithDevTools({ name: 'OnFleet Store' });
const store = createStore(
  combineReducers<Reducer<CombinedState<AppStates>, AnyAction>>({
    providersConfig: providerConfigReducer,
    logPage: logPageReducer,
    manifestConfig: manifestConfigReducer,
  }),
  composeEnhancers(applyMiddleware(thunk)),
);

export default store;
